import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import listViewFormattingRulesHydrateJqlOldQueryParameters from '@atlassian/jira-relay/src/__generated__/RuleListOldHydrateJqlQuery.graphql';
import listViewFormattingRulesOldQueryParameters from '@atlassian/jira-relay/src/__generated__/RuleListOldQuery.graphql';

export const conditionalFormattingSidebarEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-conditional-formatting-nin-sidebar" */ './index.tsx'),
	),
	getPreloadProps: ({
		projectKey,
		cloudId,
		hydrateJql,
	}: {
		projectKey: string;
		cloudId: string;
		hydrateJql: string;
	}) => ({
		queries: {
			listViewFormattingRulesQuery: {
				parameters: listViewFormattingRulesOldQueryParameters,
				variables: {
					projectKey,
					cloudId,
					first: 20,
				},
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
			},
			listViewFormattingRulesHydrateJqlQuery: {
				parameters: listViewFormattingRulesHydrateJqlOldQueryParameters,
				variables: {
					cloudId,
					jql: hydrateJql,
				},
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
			},
		},
	}),
});
